import { setWasmUrl } from '@lottiefiles/dotlottie-react';
// The WASM that matches the installed @lottiefiles/dotlottie-web version, bundled
// via the package's exported `./dotlottie-player.wasm` subpath so it can never
// drift from the player.
import wasm from '@lottiefiles/dotlottie-web/dotlottie-player.wasm';
import { Asset } from 'expo-asset';

/**
 * Points the dotLottie web player at the bundled, same-origin WASM. We self-host
 * it because the player's default jsdelivr/unpkg CDN URLs are blocked by the page
 * CSP (`connect-src` has no CDN), which left the animation card blank;
 * `connect-src 'self'` allows our own origin. `Asset.fromModule(...).uri` is
 * baseUrl-aware (`/onboarding`), so the path resolves correctly under hosting.
 *
 * `setWasmUrl` is a global, idempotent setter on both DotLottie + DotLottieWorker,
 * so this must run once at startup BEFORE any LottieView (DotLottieReact) mounts.
 * Web-only; native uses the native lottie renderer (no WASM/CDN) — see the no-op pair.
 */
export function configureDotLottieWasm(): void {
  setWasmUrl(Asset.fromModule(wasm).uri);
}
